var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.414 0.792625L15.0605 0.439125C14.475 -0.146375 13.525 -0.146375 12.9395 0.439125L7.707 5.67163L2.475 0.439125C1.889 -0.146375 0.939 -0.146375 0.3535 0.439125L0 0.792625L6.293 7.08563L0 13.3786L0.3535 13.7321C0.939 14.3176 1.889 14.3176 2.475 13.7321L7.707 8.49963L12.9395 13.7321C13.525 14.3176 14.475 14.3176 15.0605 13.7321L15.414 13.3786L9.121 7.08563L15.414 0.792625Z",
    fill: "#F3BB90"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBanner);
export default __webpack_public_path__ + "static/media/closeBanner.83d263a0cb45c58b540973acb232ca45.svg";
export { ForwardRef as ReactComponent };